import React, {Component} from 'react';
import {Col} from "react-bootstrap";
import PropTypes from 'prop-types';
import {TopAlertUwaga} from "../../componentsTopsa/alerty/TopAlerts";

/*
*
*   Komponent odpowiada za wyświetlanie wykrytych błedów podczas wysyłania formularza
*
* */

export default class ValidatorMessages extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {

        return (
            <div>
                {
                    Boolean(this.props.messages) ?
                        this.props.messages.map(m => {
                            return <Col xs={12}><TopAlertUwaga text={m}/></Col>
                        })
                        :
                        ''
                }
            </div>
        );
    }
}

ValidatorMessages.propTypes = {
    messages: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/shared/validatorMessages/ValidatorMessages.js